import { render, staticRenderFns } from "./wait-handle-list.vue?vue&type=template&id=2a2966a9&scoped=true&"
import script from "./wait-handle-list.vue?vue&type=script&lang=js&"
export * from "./wait-handle-list.vue?vue&type=script&lang=js&"
import style0 from "./wait-handle-list.vue?vue&type=style&index=0&id=2a2966a9&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a2966a9",
  null
  
)

export default component.exports